import AdvertRow from './AdvertRow.component';

export default AdvertRow;